<template>
  <!--begin::Wrapper-->
  <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
    <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
      <div class="pageBg">
        <div class="pageBgInner mt-10" data-aos="fade-up">
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div class=" bg-white rounded shadow-sm p-10 p-lg-15 mt-20 mx-auto">
                  <!--begin::Form-->
                  <Form
                    class="form w-100"
                    id="kt_login_signin_form"
                    ref="formRef"
                    @submit="onSubmitLogin"
                  >
                    <!--begin::Heading-->
                    <div class="text-center mb-10">
                                                    <span class="symbol symbol-70px symbol-circle me-6">
                                                      <span class="bg-light-danger symbol-label symbol-label">
                                                        <span class="svg-icon svg-icon-1 svg-icon-danger">
                                                                <i
                                                                  class="uil uil-user fs-1 text-danger button_icon"></i>
                                                        </span>
                                                      </span>
                                                    </span>
                      <!--begin::Title-->
                      <h1 class="text-dark mt-5 mb-3">{{ $t("register_p") }}</h1>
                      <!--end::Title-->

                    </div>
                    <!--begin::Heading-->

                    <div class="row">
                      <div class="col-md-12">
                        <p class="fs-5 m-0 fw-bolder">
                          <i class="uil uil-info-circle text-danger fs-5"></i>
                          {{ $t("main_info") }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder text-dark">{{ insideEgypt ? $t("ssn") : $t("username")
                            }}</label>
                          <!--end::Label-->
                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            style="background-color: #eee!important;"
                            type="text"
                            v-model="ssn"
                            :rules="insideEgypt ? {required:true,numeric:true,min:14,max:14} : {required:true}"
                            :label='insideEgypt ? $t("ssn") : $t("username")'
                            name="ssn" :disabled="true"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="ssn" />
                              <ErrorMessage name="personalInformation.nationalId" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6" v-if="login_method == 'phone'">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder text-dark">{{
                              $t("phone") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            style="background-color: #eee!important;"
                            type="tel"
                            v-model="phone" maxlength="11"
                            :rules="{required:true,numeric:true,min:11,max:11,regex:'(010|011|012|015)[0-9]{8}'}"
                            :label="$t('phone')"
                            name="phone" :disabled="true"
                            autocomplete="off"
                          />
                          <small class="text-success fw-bolder m-0 p-0 fs-6" v-if="true">
                            <i class="text-success uil fs-3 uil-check-circle"></i>
                            {{ $t("phone_verified") }}
                          </small>
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="phone" />
                              <ErrorMessage name="personalInformation.countryCode" />
                              <ErrorMessage name="personalInformation.phoneNumber" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6" v-if="login_method == 'email'">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder text-dark">{{
                              $t("email") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            style="background-color: #eee!important;"
                            type="tel"
                            v-model="email"
                            :rules="{required:true,email:true}"
                            :label="$t('email')"
                            name="email" :disabled="true"
                            autocomplete="off"
                          />
                          <small class="text-success fw-bolder m-0 p-0 fs-6" v-if="true">
                            <i class="text-success uil fs-3 uil-check-circle"></i>
                            {{ $t("email_verified") }}
                          </small>
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="email" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-12">
                        <hr style="background: linear-gradient(#888,transparent);height: 2px" />
                        <div class="row">
                          <div class="col-12">
                            <p class="fs-5 m-0 fw-bolder">
                              <i class="uil uil-info-circle text-danger fs-5"></i>
                              {{ $t("additional_info") }}
                            </p>
                          </div>
                          <div class="col-md-6" v-if="!insideEgypt">
                            <div class="fv-row mb-2">
                              <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("nationality")
                                }}</label>
                              <el-select class="w-100" :placeholder="$t('type_to_search')"
                                         v-model="nationality" :filterable="true">
                                <el-option
                                  v-for="(_nationality,key) in nationalities"
                                  :value="_nationality.id"
                                  :label="i18n.locale.value == 'ar' ? _nationality.value_ar : _nationality.value_en" />
                              </el-select>
                              <Field
                                class="form-control form-control-lg form-control-solid"
                                type="hidden"
                                v-model="nationality"
                                :rules="{required:true}"
                                :label="$t('nationality')"
                                name="nationality"
                                autocomplete="off"
                              />
                              <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                  <ErrorMessage name="nationality" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6" v-if="!insideEgypt">
                            <div class="fv-row mb-2">
                              <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("gender") }}</label>
                              <select name="gender" class="form-control" v-model="gender">
                                <option value="male">{{ $t("male") }}</option>
                                <option value="female">{{ $t("female") }}</option>
                              </select>
                              <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                  <ErrorMessage name="gender" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6" v-if="!insideEgypt">
                            <div class="fv-row mb-2">
                              <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("dob") }}</label>
                              <Field
                                v-model="dob"
                                name="dob"
                                :label="$t('dob')"
                                :rules="{required:true}"
                                v-slot="{ field }">
                                <flat-pickr v-bind="field" name="dob"
                                            class="form-control form-control-lg form-control-solid text-center w-100"
                                            v-model="dob" :config="{maxDate:'today'}" />
                              </Field>
                              <div class="fv-plugins-message-container">
                                <div class="fv-help-block">
                                  <ErrorMessage name="dob" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr style="background: linear-gradient(#888,transparent);height: 2px" />
                        <p class="fs-5 m-0 fw-bolder">
                          <i class="uil uil-info-circle text-danger fs-5"></i>
                          {{ $t("complete_info") }}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{
                              $t("first_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="first_name"
                            name="first_name"
                            :rules="{required:true}"
                            :label="$t('first_name')"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="first_name" />
                              <ErrorMessage name="personalInformation.firstName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{
                              $t("middle_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="middle_name"
                            :rules="{required:true}"
                            :label="$t('middle_name')"
                            name="middle_name"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="middle_name" />
                              <ErrorMessage name="personalInformation.middleName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{
                              $t("last_name") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="text"
                            v-model="last_name"
                            :rules="{required:true}"
                            :label="$t('last_name')"
                            name="last_name"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="last_name" />
                              <ErrorMessage name="personalInformation.lastName" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                      <div class="col-md-6" v-if="login_method == 'phone'">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{
                              $t("email") }}</label>
                          <!--end::Label-->

                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="email"
                            v-model="email"
                            name="email"
                            :rules="{required:true,email:true}"
                            :label="$t('email')"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="email" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->

                      </div>
                      <div class="col-md-6" v-if="login_method == 'email'">
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{
                              $t("phone") }}</label>
                          <!--end::Label-->
                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="tel"
                            v-model="phone" maxlength="11"
                            :rules="{required:true,numeric:true,min:11,max:11,regex:'(010|011|012|015)[0-9]{8}'}"
                            :label="$t('phone')"
                            name="phone"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="phone" />
                            </div>
                          </div>
                        </div>
                        <!--end::Input group-->

                      </div>
                      <div class="col-md-6">

                        <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("image") }}</label>
                        <div class="d-flex flex-wrap">
                          <button type="button" class="btn btn-dark btn-sm"
                                  :class="!image ? 'w-100' : 'w-100'"
                                  @click="triggerClickUpdate()">
                            <!---->
                            <input type="file"
                                   name="image"
                                   ref="fileImage"
                                   accept="image/jpeg, image/png, image/jpg"
                                   class="d-none"
                                   @change="handleChangeImage($event)"
                                   id="imageFile">
                            <!---->
                            <span> <i class="uil uil-image text-white button_icon"></i> {{ $t("upload_image") }} </span>
                          </button>
                          <div class="d-flex flex-column w-100 me-2 mb-5"
                               v-if="ImageLoaderProgress">
                            <div class="d-flex flex-stack mb-2"><span
                              class="text-muted me-2 fs-7 fw-bold">{{ ImageLoaderProgress }}% </span>
                            </div>
                            <div class="progress h-6px w-100">
                              <div class="progress-bar bg-danger progress-bar-striped progress-bar-animated"
                                   role="progressbar"
                                   :aria-valuenow="ImageLoaderProgress"
                                   aria-valuemin="0" aria-valuemax="100"
                                   :style="{width: ImageLoaderProgress+'%'}"></div>
                            </div>
                          </div>
                          <a v-if="image"
                             :href="$helpers.getImagePath(store.getters['moduleCommon/getConfigImagePath']+image)"
                             target="_blank"
                             class="fs-6 text-primary">
                            {{ $t("show_image") }}
                          </a>
                        </div>

                        <Field
                          class="form-control form-control-lg form-control-solid"
                          type="hidden"
                          v-model="image"
                          name="personalInformation.image"
                          :rules="{required:true}"
                          :label="$t('image')"
                          autocomplete="off"
                        />
                        <div class="fv-plugins-message-container">
                          <div class="fv-help-block">
                            <ErrorMessage name="personalInformation.image" />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <!--begin::Input group-->
                        <div class="fv-row mb-2">
                          <!--begin::Label-->
                          <label class="form-label fs-6 fw-bolder required text-dark">{{ $t("password") }}</label>
                          <!--end::Label-->
                          <!--begin::Input-->
                          <Field
                            class="form-control form-control-lg form-control-solid"
                            type="password"
                            v-model="password"
                            :rules='{required:true,regex:"^(?=.*[a-zA-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$"}'
                            :label="$t('password')"
                            name="password"
                            autocomplete="off"
                          />
                          <!--end::Input-->
                          <div class="fv-plugins-message-container">
                            <div class="fv-help-block">
                              <ErrorMessage name="password" />
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="alert alert-warning">
                            <ul style="font-size: 12px;font-weight: bold">
                              <li class="m-0 text-capitalize" style="max-height: 24px">○ {{ $t("pass_1") }}</li>
                              <li class="m-0 text-capitalize" style="max-height: 24px">○ {{ $t("pass_4") }}</li>
                              <li class="m-0 text-capitalize" style="max-height: 24px">○ {{ $t("pass_2") }}</li>
                              <li class="m-0 text-capitalize" style="max-height: 24px">○ {{ $t("pass_3") }}</li>
                            </ul>
                          </div>
                        </div>
                        <!--end::Input group-->
                      </div>
                    </div>


                    <!--begin::Actions-->
                    <div class="text-center">
                      <!--begin::Submit button-->
                      <button type="submit"
                              ref="submitButton"
                              id="kt_sign_in_submit"
                              class="btn   btn-danger    mt-5"
                      >
                        <span class="indicator-label"> {{ $t("register") }} </span>

                        <span class="indicator-progress">
                                    {{ $t("loading") }}
                                    <span
                                      class="spinner-border spinner-border-sm align-middle ms-2"
                                    ></span>
                                  </span>
                      </button>
                      <!--end::Submit button-->

                    </div>
                    <!--end::Actions-->
                  </Form>
                  <!--end::Form-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cloudsTop"></div>
      </div>
    </div>
  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, inject, unref, onMounted, onUnmounted } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import * as Yup from "yup";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Modal } from "bootstrap";
import VOtpInput from "vue3-otp-input";
import AOS from "aos";
import StorageService from "@/core/services/StorageService";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    flatPickr,
    ErrorMessage
  },
  setup(props, context) {
    const helpers: any = inject("helpers");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const i18n = useI18n();
    const { t } = useI18n();
    let formRef = ref<HTMLElement | null>(null);
    const registerPayload: any = StorageService.getStorageService("REGISTER_PAYLOAD");


    const state = reactive({
      nationalities: [],
      login_method: "phone",
      ImageModel: null,
      ImageLoaderProgress: 0,
      ImageLoader: false,

      first_name: null,
      middle_name: null,
      last_name: null,
      insideEgypt: 0,
      ssn: null,
      phone: null,
      email: null,
      password: null,
      dob: "",
      gender: "male",
      nationality: "",
      governorate: "",
      image: ""
    });

    onUnmounted(() => {

    });

    onMounted(() => {
      AOS.init();
      store.dispatch("moduleCommon/getCountries", {}).then((data) => {
        state.nationalities = data.data
      });
      if (registerPayload) {
        state.phone = (registerPayload.phoneNumber);
        state.ssn = (registerPayload.nationalId);
        state.insideEgypt = (registerPayload.insideEgypt);
        state.email = (registerPayload.email);
        state.login_method = (registerPayload.login_method);
        let token: any = route.params.token;
        window.localStorage.setItem("id_token", token);
        return;
      } else {
        helpers.errorNotify(t("error"), t("error_msg"));
        router.push({ name: "login_page" });
      }
    });

    const submitButton = ref<HTMLElement | null>(null);

    //Form submit function
    const onSubmitLogin = (values, form) => {
      if (!form) {
        return;
      }


      const { setErrors } = form;


      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "true");
      }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        let payload = {
          "email": state.email,
          "personalInformation": {
            "firstName": state.first_name,
            "middleName": state.middle_name,
            "lastName": state.last_name,
            "image": state.image,
            "countryCode": "20",
            "phoneNumber": state.phone,
            "password": state.password,
            "dob": state.dob,
            "nationality": state.nationality,
            "gender": state.gender
          },
          "password": state.password
        };
        store
          .dispatch("moduleAuth/register", payload)
          .then((response) => {
            helpers.successNotify(t("success"), t("success_msg"));
            router.push({ name: "all_programs_page" }).then(() => {

              StorageService.destroyStorageService("REGISTER_PAYLOAD");
            });
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          })
          .catch((response) => {
            if (!helpers) {
              return;
            }
            helpers.handleResponse(response, t, router, store, { setErrors });
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          });

      }, 1000);
    };


    const triggerClickUpdate = () => {
      let element = document.getElementById("imageFile");
      if (element) element.click();
    };
    const handleChangeImage = (evt: Event | any) => {
      let file = evt.target.files[0];
      let payload = new FormData();
      payload.append("path", "UserProfile");
      payload.append("isPublic", "false");
      if (helpers.getUserId()) payload.append("userId", helpers.getUserId());
      payload.append("files", file);
      state.ImageModel = file;
      uploadImage(payload);
    };
    const uploadImage = (payload) => {
      state.ImageLoader = true;
      state.ImageLoaderProgress = 0;
      let config: any = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: function(progressEvent) {
          let uploadPercentage: number = (Math.round(((progressEvent.loaded / progressEvent.total) * 100)));
          state.ImageLoaderProgress = uploadPercentage;
        }
      };
      let requestData = {
        formData: payload,
        config: config
      };
      setTimeout(() => {
        store.dispatch("moduleCommon/uploadImage", requestData).then(({ data }) => {
          state.ImageLoader = false;
          // state.image = data.image.path;
          if (data.filesUrls[0]) {
            // state.image = (new URL(data.filesUrls[0])).pathname;
            const queryString = (new URL(data.filesUrls[0])).search;
            const urlParams = new URLSearchParams(queryString);
            let filePath: any = urlParams.get("filePath");
            state.image = filePath;
          }
          setTimeout(() => {
            state.ImageLoaderProgress = 0;
          }, 1000);
        }).catch((response) => {
          state.ImageLoader = false;
          state.ImageLoaderProgress = 0;
          helpers.handleResponse(response, i18n.t, router, store);
        });
      }, 10);
    };

    return {
      triggerClickUpdate,
      handleChangeImage,
      ...toRefs(state),
      onSubmitLogin, i18n, store,
      formRef,
      submitButton
    };
  }
});
</script>
<style>

.otp-input {
  width: 35px;
  height: 35px;
  padding: 5px;
  margin: 0 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
